import moment from "moment";
import { fetchConToken } from "../../helpers/fetch";
import { handleErrorApi } from "../../helpers/randoms";
import { types } from "../../types/types";
import { startAlerta } from "../ui/alertas";
import { finishSpinner, startSpinner } from "../ui/spinner";
import { RECLAMOS_ESTADOS } from "../../utils/constants";


export const NuevoReclamoEfector = (datos) => async (dispatch) => {
    try {
      
        dispatch(startSpinner());
        const response = await fetchConToken(`Reclamos/IngresoReclamoEfector`, datos, "POST");

        const body = await response.json();
        if (response.ok) {
            dispatch(startAlerta("Reclamo creado correctamente", 'success', 'Comando Exitoso'))
            dispatch({
                type: types.tomarReclamoIngresado,
                payload: body
            })
            //dispatch(enviarMailReclamo(body[0].id))
            dispatch(TraerReclamoEfectorPorId(body[0].id))
            dispatch(finishSpinner());
            
        } else {
            throw body;
        }
    } catch (error) {
        dispatch(finishSpinner());
        handleErrorApi(dispatch, error, "Error al crear el reclamo.", "Ha ocurrido un error. Intente nuevamente")
    }
};

export const TraerReclamoPorIdEfector = (idEfector) => async (dispatch) => {
    try {
        const response = await fetchConToken(`Reclamos/TraerPorIdEfector/${idEfector}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamoPorIdEfector,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar.", "Ha ocurrido un error. Intente Nuevamente")
    }

}


export const TraerReclamoEfectorPorId = (id) => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamoEfectorIdReclamo/${id}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosTodos,
                payload: body[0]
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar .", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const TraerReclamosEfector = (estado, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamosEfectoresTodos?estado=${+estado}&destino=${area}&subDestino=${subArea!==null ? subArea : 0}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.traerReclamosEfectoresTodos,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al traer los reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const cambiarEstadoReclamoEfector = (data, estadoSolicitudes, areasFisicasUsuario, fechaInicio, fechaFin) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       
       const response = await fetchConToken(`Reclamos/CambiarEstadoReclamoEfector`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(TraerReclamosEfector(estadoSolicitudes, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin));
           dispatch(startAlerta("Cambio realizado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al modificar.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const FetchComentariosEfector = (idReclamo) => async (dispatch) => {
    
    try {
        const response = await fetchConToken(`Reclamos/TraerComentariosEfector/${idReclamo}`);
        const body = await response.json();

        if (response.ok) {
            dispatch({
                type: types.reclamosGetComentariosSolicitudesSuccess,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los comentarios de Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const agregarComentarioEfector = (idReclamo, comentario, idTipoComentario) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idreclamo : idReclamo,
           comentario: comentario,
           idTipoComentario: idTipoComentario
       }
       const response = await fetchConToken(`Reclamos/IngresarComentarioEfector`, data, "POST");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Comentario creado correctamente", 'success', 'Comando Exitoso'));
           dispatch(FetchComentariosEfector(idReclamo))
           dispatch(finishSpinner());
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al crear comentario.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const BuscadorBandejaPorCuit = (cuit, destino, subDestino, estado, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/BuscadorPorCuit?cuit=${+cuit}&destino=${destino}&subDestino=${subDestino!==null ? subDestino : 0}&estado=${estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamosEfectoresTodos,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const BuscadorBandejaPorIdReclamoEfector = (idReclamo, destino, subDestino, estado, fechaInicio, fechaFin) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/BuscadorPorIdReclamoEfector?idReclamo=${+idReclamo}&destino=${destino}&subDestino=${subDestino!==null ? subDestino : 0}&estado=${estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamosEfectoresTodos,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const updateDerivacionReclamoEfector = (idReclamo, derivado, subDerivado, areasFisicasUsuario, fechaInicio, fechaFin, descDerivadoA,descSubDerivadoA) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       const data = {
           idReclamo : idReclamo,
           derivado: derivado,
           subDerivado: subDerivado !== null ? subDerivado : 0,
           derivadoAnt: descDerivadoA,
           subDerivadoAnt: descSubDerivadoA !== null ? descSubDerivadoA : ""
           


       }
       const response = await fetchConToken(`Reclamos/UpdateDerivacionEfector`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Derivado correctamente", 'success', 'Comando Exitoso'));
           dispatch(TraerReclamosEfector(RECLAMOS_ESTADOS.PENDIENTE, areasFisicasUsuario.idArea, areasFisicasUsuario.idSubArea, fechaInicio, fechaFin))
           dispatch(finishSpinner());
           
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al derivar.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const anularReclamoEfector = (idReclamo, area, subArea, fechaInicio, fechaFin) => async (dispatch) => {

    try {
       dispatch(startSpinner());
       const data = {
           idReclamo : idReclamo
       }
       const response = await fetchConToken(`Reclamos/AnulacionReclamoEfector`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Reclamo anulado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           dispatch(TraerReclamosEfector(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio,fechaFin))
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al anular.", "Ha ocurrido un error. Intente nuevamente")
   }
};


export const finalizarReclamoEfector = (idReclamo, area, subArea,fechaInicio, fechaFin) => async (dispatch) => {

    try {
       dispatch(startSpinner());
       const data = {
        idReclamo : idReclamo
       }
       const response = await fetchConToken(`Reclamos/FinalizarReclamoEfector`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(startAlerta("Reclamo finalizado correctamente", 'success', 'Comando Exitoso'));
           dispatch(finishSpinner());
           dispatch(TraerReclamosEfector(RECLAMOS_ESTADOS.PENDIENTE, area, subArea, fechaInicio, fechaFin))
           
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al finalizar reclamo.", "Ha ocurrido un error. Intente nuevamente")
   }
};

export const InsertarOrigenErorrReclamoEfector = (data) => async (dispatch) => {
    try {
       dispatch(startSpinner());
       
       const response = await fetchConToken(`Reclamos/OrigenErrorReclamoEfector`, data, "PUT");
       const body = await response.json();
       if (response.ok) {
           dispatch(finishSpinner());
       } else {
           throw body;
       }
   } catch (error) {
       dispatch(finishSpinner());
       handleErrorApi(dispatch, error, "Error al insertar el origen del error.", "Ha ocurrido un error. Intente nuevamente")
   }
};



export const TraerReclamosEnviadosEfector = ( estado, fechaInicio, fechaFin, idEfector) => async (dispatch) => {
    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    try {
        const response = await fetchConToken(`Reclamos/TraerReclamosEnviadosEfector?estado=${+estado}&fechaInicio=${fechaInicioMod}&fechaFin=${fechaFinMod}&idEfector=${idEfector!==null ? idEfector : 0}`);
        const body = await response.json();
        if (response.ok) {
            dispatch({
                type: types.traerReclamosEnviados,
                payload: body
            })
        }else {
            throw body;
        }
    } catch (error) {
        handleErrorApi(dispatch, error, "Error al cargar los Reclamos.", "Ha ocurrido un error. Intente Nuevamente")
    }

}

export const generarExcelReclamosEnviadosEfector = ( estado, fechaInicio, fechaFin, idEfector) => async (dispatch) => {

    let fechaInicioMod = fechaInicio instanceof Date ? moment(fechaInicio).format() : '';
    let fechaFinMod = fechaFin instanceof Date ? moment(fechaFin).format() : '';
    let idEfectorMod = idEfector!==null ? idEfector : 0
    try {
        const response = await fetchConToken(`Reclamos/GenerarExcelReclamosEnviadosEfector/${estado},${fechaInicioMod},${fechaFinMod},${idEfectorMod}`);

        const body = await response.blob();
        if (response.ok) {
            dispatch(finishSpinner());
            let url = window.URL.createObjectURL(body);
            let a = document.createElement('a');
            a.href = url;
            a.download = `ReclamosEnviadosEfector.xlsx`;
            a.click();
          } else {
            throw body;
          }
        } catch (error) {
          dispatch(finishSpinner());
          handleErrorApi(
            dispatch,
            error,
            "Error al traer el excel",
            "Ha ocurrido un error. Intente nuevamente"
          );
        }

}










